import { Link as RouterLink } from "react-router-dom-v5-compat";
import PropTypes from "prop-types";
import { AppBar, Box, Hidden, IconButton, Toolbar } from "@mui/material";
import { experimentalStyled } from "@mui/material/styles";
import MenuIcon from "../../icons/Menu";
import AccountPopover from "./AccountPopover";

import Logo from "../Logo";

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === "light" && {
    backgroundColor: theme.palette.primary.main,
    //boxShadow: `1px solid ${theme.palette.divider}`, //"none",
    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === "dark" && {
    backgroundColor: theme.palette.primary.main,
    //borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
  }),
  zIndex: theme.zIndex.drawer + 100,
}));

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, companyid, ...other } = props;

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onSidebarMobileOpen}>
            <MenuIcon sx={{ color: "background.paper" }} fontSize="small" />
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          <RouterLink
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <Logo
              company={companyid}
              imgStyle={{ height: 36, width: "auto", maxWidth: "none" }}
              sx={{
                height: 40,
                width: 40,
              }}
            />
          </RouterLink>
        </Hidden>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default DashboardNavbar;
